export class AddArtistsToTagModel {
  id: number;
  name: string;
  imageUrl: string;
  hasTag: boolean;
}
